"use client";

import { useEffect, useRef } from "react";

/**
 * Filters a page takes from its address — `/marketplace?category=…&q=…`,
 * `/people?q=guitar`, `/releases?genre=Jazz` (Gordon 2026-11-02: coπ's "show
 * me t-shirts" opens the shop showing only t-shirts). Read on mount, on
 * back/forward, and on `bb-url-params` — fired by coπ after it changes the
 * address of the page you're already on (that doesn't remount the page).
 * Plain window.location instead of useSearchParams: no Suspense boundary
 * needed on statically rendered pages.
 */
export function useUrlParams(onChange: (params: URLSearchParams) => void) {
  const cb = useRef(onChange);
  cb.current = onChange;
  useEffect(() => {
    const read = () => { try { cb.current(new URLSearchParams(window.location.search)); } catch { /* ignore */ } };
    read();
    window.addEventListener("popstate", read);
    window.addEventListener("bb-url-params", read);
    return () => {
      window.removeEventListener("popstate", read);
      window.removeEventListener("bb-url-params", read);
    };
  }, []);
}
